/*
  Keeps --snize-viewport-height in sync with the part of the screen the user can actually see.

  Searchanise opens its mobile search panel with an inline `height: <window.innerHeight>px`
  and never recalculates it. Android Chrome shrinks the layout viewport when the soft
  keyboard opens, so the panel stays taller than the visible area and the results below the
  fold become unreachable. iOS does not resize the layout viewport, which is why the bug
  only showed up on Android.

  visualViewport is the only measurement that is correct on every browser here, so the
  panel height in component-search.css reads from this variable.
*/
(function () {
  var root = document.documentElement;
  var viewport = window.visualViewport;

  if (!viewport) return; // CSS falls back to 100dvh / 100vh.

  var frame = null;

  function apply() {
    frame = null;
    root.style.setProperty('--snize-viewport-height', viewport.height + 'px');
  }

  function schedule() {
    if (frame !== null) return;
    frame = window.requestAnimationFrame(apply);
  }

  apply();

  viewport.addEventListener('resize', schedule);
  viewport.addEventListener('scroll', schedule);
  window.addEventListener('orientationchange', schedule);
})();
